/* import __COLOCATED_TEMPLATE__ from './project-details-create-project-summary.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask, timeout } from 'ember-concurrency';

const RERENDER_TIMEOUT = 120_000;

const identity = (x) => x;

class ProjectDetailsCreateProjectSummaryComponent extends Component {
  @tracked
  counter = 0;

  get createdAt() {
    // need to entangle the `counter` property so that this will trigger a rerender
    // on an interval
    return identity(this.args.createdAt, this.counter);
  }

  @action
  toggleTimeMode(e) {
    e.stopPropagation();

    this.args.onTimeModeToggled();
  }

  @action
  enableIncrementCounter(_, [isAbsoluteTimeEnabled]) {
    if (isAbsoluteTimeEnabled) {
      this.incrementCounter.cancelAll({ resetState: true });
    } else {
      this.incrementCounter.perform();
    }
  }

  @dropTask
  *incrementCounter() {
    while (true) {
      yield timeout(RERENDER_TIMEOUT);
      this.counter += 1;
    }
  }
}

export default ProjectDetailsCreateProjectSummaryComponent;
